<template>
  <div id="sliderContent">
    <div id="slider">
      <VueSlickCarousel @afterChange="afterChange" v-bind="sliderSettings">
        <div @click="gotoLink(item.link)" class="sliderItem" v-for="(item, index) in slider"  :key="index">
          <img  :src="`${$root.baseImageUrl}${$root.screenSize>1000?item.image:item.mobileImage}`" :alt="item.title" />
          <!-- <h3 v-if="item.title">{{ item.title }}</h3>
          <p v-if="item.shortDesc">{{ item.shortDesc }}</p> -->
        </div>
      </VueSlickCarousel>
    </div>
    <div id="bottomWall" class="width100">
      <div
        id="content"
        class="d-flex justify-content-start width90 height100 hiddenInMobile"
      >
        <p
          id="wallTitle"
          class="d-flex justify-content-center align-items-center"
        >
{{$cookie.get('ltrTheme')?'Margarine Company Calibration Laboratory':'آزمايشگاه كاليبراسيون شركت مارگارين'}}        </p>
        <div id="sliderPagination"></div>
      </div>
    </div>
  </div>
</template>
<script>
import VueSlickCarousel from "vue-slick-carousel";

export default {
  components: {
  
    VueSlickCarousel
  },
  props:{
    slider:Array
  },
  data() {
    return {
      sliderSettings: {
        dots: true,
        arrows: false,
        dotsClass: "slick-dots custom-dot-class",
        edgeFriction: 0.35,
        fade:true,
        infinite: false,
        autoplay: true,
        pauseOnHover:false,
        speed: 3500,
        autoplaySpeed: 3000,
        slidesToShow: 1,
        slidesToScroll: 1
      },

      
    };
  },
  mounted() {
    this.setStyle();
    window.addEventListener("resize", this.setStyle);
    // setTimeout(() =>{
    //   this.sliderSettings.infinite=true;
    //   this.sliderSettings.autoplay=true;
    // },1000)
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setStyle);
  },
  methods: {
    afterChange(number){
      if(number==this.slider.length-1){
        this.sliderSettings.initialSlide=0
        this.sliderSettings.infinite=true;
      }else{
        // this.sliderSettings.infinite=false;
      }
    },
    gotoLink(link){
      if(link==null)return;
      window.open(link, '_blank');
    },
    setStyle() {
      if (window.innerWidth > 1000) {
       this.$root.unsetInlineStyle("font-size","#homeSection #sliderSection #sliderContent #slider .sliderItem p")
       this.$root.unsetInlineStyle("font-size","#homeSection #sliderSection #sliderContent #slider .sliderItem h3")
      } else {
      
        this.$root.setProportionStyle(
          "font-size",
          "px",
          "#homeSection #sliderSection #sliderContent #slider .sliderItem h3",
          1000,
          40,
          425,
          28
        );
        this.$root.setProportionStyle(
          "font-size",
          "px",
          "#homeSection #sliderSection #sliderContent #slider .sliderItem p",
          1000,
          36,
          425,
          26
        );
      }
    }
  }
};
</script>
  <style scoped>
#sliderContent #slider .slick-dots {
  z-index: 2;
  width: max-content;
  right: 6%;
  bottom: 0%;
}
#sliderContent #slider .slick-dots li button:before {
  content: "___";
}
#sliderContent #slider .slick-dots li button:before {
  font-size: 16px;
  font-weight: bolder;
  color: #c4beb8;
}
#sliderContent #slider .slick-dots li.slick-active button:before {
  color: #f8941c;
}
/* #sliderContent{
  scroll-behavior: unset;
  object-fit:  fill;
  overflow:visible;
}
.slick-slider{
  height: 500px;
}
.slick-dots {
  display: none;
} */
</style>  
